// « Aujourd'hui », vu de l'appareil de l'utilisateur (31/07/2026).
//
// Le motif remplacé partout : `new Date().toISOString().slice(0, 10)`.
// `toISOString()` rend la date en UTC. Kinshasa étant à UTC+1, entre MINUIT et
// 1 H DU MATIN la date UTC est encore celle de LA VEILLE : un champ « date du
// jour » s'ouvrait donc sur hier, et une dépense saisie à 00h30 partait au
// mauvais jour. Le défaut est silencieux — la date proposée a l'air normale.
//
// On construit la chaîne à partir des composantes LOCALES : ce que dit
// l'horloge du téléphone ou du PC, ce que demande le propriétaire.

// 'AAAA-MM-JJ' du jour local (format attendu par <input type="date">).
export const jourLocal = (date = new Date()) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Idem avec un décalage en jours (hier = -1, demain = +1). Passe par setDate,
// qui gère les fins de mois et les années bissextiles.
export const jourLocalDecale = (jours, base = new Date()) => {
  const d = new Date(base);
  d.setDate(d.getDate() + Number(jours || 0));
  return jourLocal(d);
};

export default jourLocal;
